// Single source of truth for the sales landing page's header navigation.
// SalesPage.vue uses these directly to scroll within the page. The public
// legal pages (TermsAndConditionsPage.vue, PrivacyPolicyPage.vue) import the
// same arrays so the header looks and reads identically, but their click
// handlers navigate back to the sales page (with a scrollTo query param)
// instead of scrolling in-page.
export const SALES_NAV_ITEMS = [
  { id: 'why-bcspro', label: 'Why BCSPro', target: 'why-bcspro' },
  { id: 'our-product', label: 'Our Product', target: 'our-product' },
  { id: 'testimonials', label: 'Testimonials', target: 'testimonials' },
  { id: 'founders-note', label: 'Founder\u2019s Note', target: 'founders-note' },
  { id: 'FAQs', label: 'FAQs', target: 'FAQs' }
]

export const SALES_ACTION_ITEMS = [
  { id: 'request-demo', label: 'Request a Demo', type: 'button', primary: true, showMobile: true },
  { id: 'signin', label: 'Sign In', type: 'button', primary: false, showMobile: false }
]
